export const navLinks = [
  { label: 'Inicio', href: '#inicio' },
  { label: 'Nosotros', href: '#nosotros' },
  { label: 'Servicios', href: '#servicios' },
  { label: 'Proyectos', href: '#proyectos' },
  { label: 'Contacto', href: '#contacto' },
]

export const clientLogos = [
  'Northwind',
  'Vertexa',
  'Lumina',
  'Corvex',
  'Aurora Labs',
  'Meridian',
  'Solventa',
  'Kaido',
]

export const values = [
  {
    title: 'Innovación',
    description: 'Aplicamos tecnología moderna para crear soluciones eficientes.',
  },
  {
    title: 'Calidad',
    description: 'Cada proyecto se desarrolla con altos estándares.',
  },
  {
    title: 'Escalabilidad',
    description: 'Pensamos en soluciones preparadas para crecer.',
  },
  {
    title: 'Compromiso',
    description: 'Trabajamos enfocados en resultados reales.',
  },
]

export const services = [
  {
    title: 'Desarrollo Web',
    description: 'Sitios y aplicaciones a medida, rápidas, seguras y fáciles de mantener.',
  },
  {
    title: 'Landing Pages',
    description: 'Páginas de alto impacto diseñadas para convertir visitas en clientes.',
  },
  {
    title: 'E-commerce',
    description: 'Tiendas online con procesos de compra claros y pagos integrados.',
  },
  {
    title: 'Automatización',
    description: 'Flujos e integraciones que eliminan tareas manuales repetitivas.',
  },
  {
    title: 'Marketing Digital',
    description: 'Estrategias de adquisición medibles y enfocadas en el retorno.',
  },
  {
    title: 'Consultoría',
    description: 'Acompañamiento técnico para tomar mejores decisiones de producto.',
  },
]

export const processSteps = [
  {
    title: 'Descubrimiento',
    description: 'Entendemos tu negocio, tus usuarios y los objetivos del proyecto.',
  },
  {
    title: 'Planificación',
    description: 'Definimos alcance, arquitectura y prioridades con fechas claras.',
  },
  {
    title: 'Desarrollo',
    description: 'Construimos en ciclos cortos con entregas visibles y revisables.',
  },
  {
    title: 'Implementación',
    description: 'Lanzamos con pruebas, monitoreo y traspaso documentado.',
  },
  {
    title: 'Optimización',
    description: 'Medimos resultados y mejoramos de forma continua.',
  },
]

export const results = [
  { value: '+250', label: 'Proyectos' },
  { value: '+98%', label: 'Clientes satisfechos' },
  { value: '+15', label: 'Países' },
  { value: '+5 años', label: 'Experiencia' },
]

export const testimonials = [
  {
    name: 'Valentina Rojas',
    company: 'Directora de Marketing, Lumina',
    quote:
      'Almaria rediseñó por completo nuestra presencia digital. En tres meses duplicamos las solicitudes de contacto y el equipo dejó de depender de terceros para publicar cambios.',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/567e69ee-e1dd-42eb-b21b-4975c3ec27b2.jpg',
  },
  {
    name: 'Andrés Moreira',
    company: 'CEO, Corvex Logistics',
    quote:
      'Automatizaron procesos que nos consumían horas cada semana. Lo más valioso fue su claridad: siempre supimos qué se estaba construyendo y por qué.',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/3b81dcc1-0fb2-4fed-bf0b-51733d0c91e3.jpg',
  },
  {
    name: 'Diego Salazar',
    company: 'Fundador, Kaido Store',
    quote:
      'Nuestro e-commerce pasó de ser lento y frágil a una plataforma estable que soporta campañas grandes sin problemas. Un equipo realmente confiable.',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/ef594fcf-18db-4888-81f1-3e5e8cc45e63.jpg',
  },
]

export const footerColumns = [
  {
    title: 'Empresa',
    links: ['Nosotros', 'Equipo', 'Cultura', 'Trabaja con nosotros'],
  },
  {
    title: 'Servicios',
    links: ['Desarrollo Web', 'E-commerce', 'Automatización', 'Consultoría'],
  },
  {
    title: 'Recursos',
    links: ['Casos de éxito', 'Blog', 'Guías', 'Preguntas frecuentes'],
  },
]

export const projects = [
  {
    client: 'Meridian Health',
    title: 'Portal de pacientes con agenda en línea',
    tag: 'Producto digital',
    metric: '−42% llamadas al call center',
  },
  {
    client: 'Kaido Store',
    title: 'Migración de e-commerce y checkout propio',
    tag: 'E-commerce',
    metric: '+31% conversión móvil',
  },
  {
    client: 'Corvex Logistics',
    title: 'Automatización de reportes operativos',
    tag: 'Automatización',
    metric: '120 horas ahorradas al mes',
  },
]
